<ivd-widget-product-picker *ngIf="products$ | async as products" [apps]="products" [language]="language$ | async"
  [iconColor]="iconColor ?? 'white'"></ivd-widget-product-picker>
